export default {"src":"/_next/static/media/role-students.099e0f2a.svg","height":72,"width":75,"blurWidth":0,"blurHeight":0};